export const BLACK = '#000000';
export const ORANGE_BLACK = '#121212';
export const WHITE = '#FFFFFF';
export const LIGHT_GREY = '#D9D9D9';
export const DARK_GREY = '#B3B3B3';
export const DARKER_GREY = '#212121';
export const DARKEST_GREY = '#404040';
export const MECURY = '#E2E2E2';
export const MINE_SHAFT = '#282828';
export const ORANGE = '#F87303';
export const ORANGE_PEEL = '#F79C05';
export const SINOPIA = '#CE4906';
export const CHILEAN_FIRE = '#F66605';

const ORANGE_BLACK_GRADIENT = 'linear-gradient(180deg, #00000000 0%, #121212 100%)';

const GRADIENT_START = '#000000';

const GRADIENT_END = '#F87E0326';

export const LINEAR_GRADIENT = 'linear-gradient(180deg, #00000000 0%, #F87E0326 100%)';
export const GREY_GRADIENT = 'linear-gradient(180deg, #D9D9D9 0%, #B3B3B3 100%)';

// Prepare the colors to be used by TailwindCSS
export const colors = {
    colors: {
        black: BLACK,
        white: WHITE,
        light_grey: LIGHT_GREY,
        dark_grey: DARK_GREY,
        darker_grey: DARKER_GREY,
        mercury: MECURY,
        mine_shaft: MINE_SHAFT,
        orange: ORANGE,
        orange_peel: ORANGE_PEEL,
        orange_black: ORANGE_BLACK,
        sinopia: SINOPIA,
        chilean_fire: CHILEAN_FIRE,
        linear_gradient: LINEAR_GRADIENT,
        grey_gradient: GREY_GRADIENT,
        gradient_start: GRADIENT_START,
        gradient_end: GRADIENT_END,
        orange_black_gradient: ORANGE_BLACK_GRADIENT,
        // Declare color with theme dark and light
        primary: {
            light: ORANGE,
            dark: ORANGE,
        },
        secondary: {
            light: ORANGE_PEEL,
            dark: ORANGE_PEEL,
        },
        tertiary: {
            light: SINOPIA,
            dark: SINOPIA,
        },
        quaternary: {
            light: CHILEAN_FIRE,
            dark: CHILEAN_FIRE,
        },
        background: {
            light: WHITE,
            dark: BLACK,
        },
        text: {
            light: BLACK,
            dark: WHITE,
        },
        border: {
            light: DARK_GREY,
            dark: MECURY,
        },
        input_background: {
            light: MECURY,
            dark: MINE_SHAFT,
        },
        auth_body: {
            light: WHITE,
            dark: ORANGE_BLACK,
        },
        body: {
            light: WHITE,
            dark: BLACK,
        },
        toggleBorder: {
            light: MINE_SHAFT,
            dark: MECURY,
        },
    },
};

// Export the colors to be used by TailwindCSS
export default colors;